import Layout from "../../components/Layout/Layout";
import { useEffect, useState } from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import Button from "../../components/Button/Button";
import Table from "../../components/Table/Table";
import { TableSearch } from "../../components/Table/TableActions";
import Modal from "../../components/Modal";
import { Icon } from "@iconify/react";

// --| Dummy data
import teacherData from "../../dummy_data/teacher.json";
import { Link } from "react-router-dom";

const Teachers = () => {
  const [searchResult, setSearchResult] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [currentRow, setCurrentRow] = useState({});

  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  // On Page Load, set search result data to be the initial data
  useEffect(() => {
    // The data will be from the teacher get api endpint
    setSearchResult(teacherData);
  }, []);
  const columns = [
    {
      name: "Name",
      selector: row => row?.name
    },
    {
      name: "Email Address",
      selector: row => row?.email
    },
    {
      name: "Class",
      selector: row => row?.student_class
    },
    {
      name: "Gender",
      selector: row => row?.gender
    },
    {
      name: "Parent/Guardian",
      selector: row => row?.parent
    },
    {
      name: "Contact",
      selector: row => row?.contact
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <Link to={`/teachers/${row?.id}`} className="table-action-icon">
            <Icon icon="fluent:eye-16-regular" />
          </Link>
          <Link to={`/teachers/${row?.id}`} className="table-action-icon">
            <Icon icon="heroicons:pencil-square-solid" />
          </Link>
          <button
            onClick={() => handleDeleteModal(row)}
            className="table-action-icon delete-icon"
          >
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];

  // --| Filter Teacher table using name, email and class
  const handleSearchTeacher = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = teacherData?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                    data?.email
                      ?.toLowerCase()
                      .includes(word.toLowerCase()) ||
                    data?.class
                      ?.toLowerCase()
                      .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Teachers"
            subtitle="See all the teachers in your establishment."
            button={
              <div className="flex gap-10">
                <Button
                  variant="primaryoutline"
                  buttonSize="small"
                  color="btnfontprimary"
                  buttonName="Performance"
                />
                <Button
                  variant="primary"
                  buttonSize="small"
                  color="btndefault"
                  buttonName="Add employee"
                />
              </div>
            }
          />
          <Table data={searchResult} columns={columns} subHeader={true} subHeaderComponent={
            <TableSearch placeholder="Search here..." searchTableFunc={handleSearchTeacher} />
          }
          />
          <Modal
            title="Off board employee"
            subtitle={
              <div>Are you sure you want to off board <span className="modal-name-highlight">{currentRow?.name}</span>. If leave off boarded, employee will no longer have access to this platform.`
              </div>}
            modalContent={
              <>

              </>
            }
            modalFooter={
              <>
                <Button variant="danger" buttonName="Off board Employee" buttonSize="full" color="btndefault" />
              </>
            }
            isopen={deleteModal}
            closeModal={handleCloseDeleteModal}
          />
        </>
      }
    />
  );
};

export default Teachers;
